import actions from './actions'
import mutations from './mutations'

const payout = {
    namespaced: true,
    state: {
        payouts: [],
        pagination: {
            length: null,
            page: 1,
            total: null
        },
        isLoaded: true,
        filters: {
            status: null,
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0], // current date minus month
            toDate: new Date().toISOString().split('T')[0],
            query: null
        }
    },
    mutations,
    actions
}

export default payout
